import React from 'react';
import { motion } from 'framer-motion';
import './PolicyPage.css';

const CookiePolicy = () => {
  return (
    <section className="policy-page section">
      <div className="container">
        <motion.div 
          className="policy-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>🍪 Cookie Policy</h1>
          <p className="last-updated">Last updated: June 11, 2025</p>
          
          <p>Our Cookie Policy explains how and why we use cookies on www.digitalfig.com.</p>

          <h2>What is a cookie?</h2>
          <p>A small text file stored on your device, used to remember preferences or track site usage.</p>

          <h2>Types of cookies we use</h2>
          <ul>
            <li><strong>Necessary:</strong> Essential for site operation.</li>
            <li><strong>Analytics:</strong> e.g., Google Analytics cookies (_ga, _gid) for usage insights.</li>
            <li><strong>Marketing:</strong> Track user interests for advertising.</li>
          </ul>

          <h2>Managing cookies</h2>
          <p>You may accept or decline cookies when visiting the Site.</p>
          <p>Use browser settings to block or delete cookies, although this may impair some features.</p>

          <h2>Third-party cookies</h2>
          <p>These may be set by external services (like analytics or ad platforms) and are subject to their own privacy policies.</p>

          <h2>Changes</h2>
          <p>We may update this policy as needed. The "Last updated" date will reflect any updates.</p>

          <h2>Contact</h2>
          <p>Questions? Email <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a>.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default CookiePolicy;